export default "__VITE_ASSET__CWKsBjfn__"